export class SensorDataPostModel {
    public LocationName:string;
    public SensorType:string; 
    public LogDate:Date
}
